import { useEffect } from 'react';

import { ProductOptionContainer } from '../container/ProductOptionContainer';
import { SizeInfoBannerContainer } from '../container/SizeInfoBannerContainer';
import { ProductOptionProvider } from '../context/ProductOptionProvider';
import { GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_option_size_recommendation as PdpOptionSizeRecommendation } from '../graphql/select-option_types.2';
import { useGetProductIdInQueryParams } from '../hook/useGetProductIdInQueryParams';
import { useProductOptionHydrate } from '../hook/useProductOptionHydrate';
import { usePageViewLog } from '../log/usePageViewLog';
import type { ProductOptionProps } from '../type/common.type';

interface Props
  extends Pick<
    ProductOptionProps,
    'productId' | 'preloadedOptionData' | 'open' | 'use_drawer' | 'context' | 'config' | 'onClose'
  > {}

export const ProductOptionScreen = ({
  productId,
  preloadedOptionData,
  open,
  use_drawer = true,
  context,
  config,
  onClose = () => undefined,
}: Props) => {
  const pageviewLog = usePageViewLog();
  const queryParamsProductId = useGetProductIdInQueryParams();
  const id = productId ?? queryParamsProductId;
  const hydratedState = useProductOptionHydrate({
    option_info: preloadedOptionData,
    config,
  });

  useEffect(() => {
    // MEMO: 네이티브 PDP에서는 적재하지 않고 웹 PDP에서만 로그 전송하도록 use_portal 조건 추가
    if (use_drawer && open) {
      pageviewLog.pageviewUBL(id);
    }
  }, [use_drawer, open]);

  return (
    <ProductOptionProvider initialState={hydratedState ?? undefined}>
      <ProductOptionContainer
        productId={id}
        open={open}
        use_drawer={use_drawer}
        context={context}
        config={{
          ...config,
          slots: {
            ...config?.slots,
            SubHeaderContent: (props: {
              isItemCardMode: boolean;
              sizeRecommendation?: PdpOptionSizeRecommendation | null;
            }) => {
              if (!props.isItemCardMode) {
                return <SizeInfoBannerContainer sizeRecommendation={props.sizeRecommendation} catalogProductId={id} />;
              }
              return null;
            },
          },
        }}
        onClose={onClose}
      />
    </ProductOptionProvider>
  );
};
